<div *ngIf="!showDisclaimerBlock"
     class="component-container flex flex-col">
  <div class="component-header flex flex-col">
    <div class="content-panel flex flex-row justify-between">
      <div class="page-heading">
        {{ !memberId ? 'My ' : '' }} Measurements
      </div>
      <app-primary-button (handleClick)="enterData(getTodayDate())" 
                          *ngIf="metricsOptions?.data?.length"
                          class="button w-[10.7rem]">
        Enter Data
      </app-primary-button>
    </div>
    <hr class="header-separator">
  </div>
  <div *ngIf="displayErrorMessage"
       class="flex flex-row space-x-[1rem]">
    <app-icon svgIcon="exclamation-circle"></app-icon>
    <div class="error-message">
      {{ displayErrorMessage }}
    </div>
  </div>

  <ng-container *ngIf="foundProfile && !metricsOptions?.loading;else
  loadingMetricOptions">
    <ng-container *ngIf="hasMetricValuesToShow;else noMetricOptions;">
      <ng-container *ngFor="let metricOption of metricsOptions?.data">
        <div *ngIf="metricOption.hasValues&&metricOption.code !== 'weight'"
             class="accordion">
          <mat-expansion-panel [expanded]="metricOption.code==='height'"
                               class="mat-elevation-z0 expansion-panel">
            <mat-expansion-panel-header class="flex flex-row justify-center items-center">
              <div *ngIf="metricOption.code==='height';else otherTitle;"
                   class="title">
                Height and Weight
              </div>
              <ng-template #otherTitle>
                <div class="title">
                  {{ metricOption.name }}
                </div>
              </ng-template>
            </mat-expansion-panel-header>

            <div class="w-full xs:overflow-x-auto sm:overflow-x-auto">
              <div class="table-container xs:w-[80rem] sm:w-[80rem] md:w-full">
                <ng-container *ngIf="!configuration[metricOption.code].loading;else loadingMetricValues">
                  <table [dataSource]="configuration[metricOption.code].data?.list"
                         mat-table>
                    <ng-container matColumnDef="addedBy">
                      <th *matHeaderCellDef
                          mat-header-cell> Entered by
                      </th>
                      <td *matCellDef="let element"
                          class="w-[20%]"
                          mat-cell>

                        <div class="role-color-circle-container flex flex-row items-center">
                          <div [style]="{ 'background-color':
                    roleDecorators[element.isCoachEntered ? 1 : 2].color}"
                               class="role-color-circle w-[0.8rem] h-[0.8rem]"></div>
                          <span [matTooltip]="element.addedBy.firstName+ ' ' +
                            element.addedBy.lastName"
                                matTooltipClass="metric-role-tooltip">{{
                              roleDecorators[element.isCoachEntered ? 1 : 2].label
                            }}</span>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="session">
                      <th *matHeaderCellDef
                          mat-header-cell> Session
                      </th>
                      <td *matCellDef="let element"
                          class="w-[20%]"
                          mat-cell> {{
                          element.session?.id ?
                            'S' + element.session?.id + ' - ' : ''
                        }}  {{ element.session?.name }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="recordedOn">
                      <th *matHeaderCellDef
                          mat-header-cell> Date
                      </th>
                      <td *matCellDef="let element"
                          class="w-[20%]"
                          mat-cell
                      >
                        {{ element.recordedOn | date: 'MM/dd/YYYY' }}
                      </td>
                    </ng-container>

                    <ng-container *ngIf="metricOption.code === 'height';else
                    nonCombinedValues;">
                      <ng-container matColumnDef="value1">
                        <th *matHeaderCellDef
                            mat-header-cell> Height (feet, inches)
                        </th>
                        <td *matCellDef="let element"
                            mat-cell>
                          <ng-container *ngIf="element.height?.value">
                            {{
                              element.height?.value |
                                heightFormat
                            }}
                          </ng-container>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="value2">
                        <th *matHeaderCellDef
                            mat-header-cell> Weight (pounds)
                        </th>
                        <td *matCellDef="let element"
                            mat-cell>
                          {{ element.weight?.value }}
                        </td>
                      </ng-container>
                    </ng-container>
                    <ng-template #nonCombinedValues>
                      <ng-container matColumnDef="value">
                        <th *matHeaderCellDef
                            mat-header-cell> {{ metricOption.name }}
                        </th>
                        <ng-container *ngIf="metricOption.code==='height';else otherValue">
                          <td *matCellDef="let element"
                              mat-cell> {{ element.value | heightFormat }}
                          </td>
                        </ng-container>
                        <ng-template #otherValue>
                          <td *matCellDef="let element"
                              mat-cell> {{ element.value }}
                          </td>
                        </ng-template>
                      </ng-container>
                    </ng-template>

                    <ng-container matColumnDef="menu">
                      <th *matHeaderCellDef
                          mat-header-cell></th>
                      <td *matCellDef="let element"
                          class="w-[5%]"
                          mat-cell>
                        <button [matMenuTriggerFor]="menu"
                                mat-icon-button>
                          <app-icon icon="more_vert"></app-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button (click)="handleEditValue(metricOption,
                        element, configuration[metricOption.code].data)"
                                  [disabled]="
element.isCoachEntered && (profileData.role === roles.adult ||
profileData.role === roles.participant)"
                                  mat-menu-item>
                            <mat-icon>edit</mat-icon>
                            <span>Edit</span>
                          </button>
                          <button (click)="handleDeleteValue(metricOption,
                        element, configuration[metricOption.code].data)"
                                  [disabled]="
element.isCoachEntered && (profileData.role === roles.adult ||
profileData.role === roles.participant)"
                                  mat-menu-item>
                            <mat-icon>delete</mat-icon>
                            <span>Delete</span>
                          </button>
                        </mat-menu>
                      </td>
                    </ng-container>

                    <tr *matHeaderRowDef="configuration[metricOption.code].config"
                        mat-header-row></tr>
                    <tr *matRowDef="let row; columns: configuration[metricOption.code].config;"
                        mat-row></tr>
                    <tr *matNoDataRow
                        class="mat-row">
                      <td [colSpan]="configuration[metricOption.code].config.length"
                          class="mat-cell w-full">
                        No data found.
                      </td>
                    </tr>
                  </table>
                  <mat-paginator (page)="handlePageChange(metricOption, $event)"
                                 [length]="configuration[metricOption.code].data?.total"
                                 [pageIndex]="configuration[metricOption.code].data?.pageNumber - 1"
                                 [pageSizeOptions]="pageSizeOptions"
                                 [pageSize]="configuration[metricOption.code].data?.limit"
                                 class="paginator-section"></mat-paginator>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #noMetricOptions>
      <div *ngIf="!displayErrorMessage"
           class="no-metric-options">
        No measurement values found.
      </div>
    </ng-template>
  </ng-container>
  <ng-template #loadingMetricValues>
    <div class="loading-metric-values">
      <mat-spinner [diameter]="60"
                   strokeWidth="5"/>
    </div>
  </ng-template>
  <ng-template #loadingMetricOptions>
    <div class="loading-metric-options">
      <mat-spinner [diameter]="60"
                   strokeWidth="5"/>
    </div>
  </ng-template>
</div>
<div *ngIf="showDisclaimerBlock"
     class="disclaimer-block-wrapper">
  <div class="flex flex-row space-x-[1rem]">
    <app-icon svgIcon="exclamation-circle"></app-icon>
    <div class="error-message">
      You or your participants are not part of any group.
    </div>
  </div>
</div>
